import getConfig from 'next/config';

import { isTelemundoVertical } from 'lib/vertical';

const adServerPreconnect = '<https://securepubads.g.doubleclick.net/>; rel="preconnect"';

export function setAdLinkHeaders(res, vertical) {
  const {
    publicRuntimeConfig: {
      MPS_URL_NBCNEWS,
      MPS_URL_TELEMUNDO,
    },
  } = getConfig();

  const mpsLibraryUrl = isTelemundoVertical(vertical)
    ? MPS_URL_TELEMUNDO
    : MPS_URL_NBCNEWS;
  const mpsLibraryLink = `<${mpsLibraryUrl}>; as="script"; rel="preload"`;

  const existingLinkHeader = res.get('Link') || '';
  const existingLinkHeaderAndSeparator = existingLinkHeader.length
    ? `${existingLinkHeader.replace(/, $/, '')}, `
    : '';

  res.set('Link', `${existingLinkHeaderAndSeparator}${adServerPreconnect}, ${mpsLibraryLink}`);
}
